import { useQuery, type QueryHookOptions } from "@apollo/client";
import type {
  VisitsByFiltersQuery,
  VisitsByFiltersQueryVariables,
} from "@/__generated__/graphql";
import { VisitsByFiltersDocument } from "@/__generated__/graphql";
import { mapToVisitData } from "@/components/shared/visits/visit-card";

export const useGetVisitsQuery = (
  options?: QueryHookOptions<
    VisitsByFiltersQuery,
    VisitsByFiltersQueryVariables
  >,
) => {
  const result = useQuery(VisitsByFiltersDocument, {
    notifyOnNetworkStatusChange: true,
    ...options,
  });
  const rawVisits = result.data?.visitsByFilters?.visits ?? [];
  const total = result.data?.visitsByFilters?.count ?? 0;
  const list = rawVisits.map(mapToVisitData);
  const canLoadMore = list.length < total;
  return { ...result, list, total, canLoadMore };
};
